import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './assets/css/global.scss';
import socketio from 'socket.io-client';
import VueSocketIO from 'vue-socket.io';
import VueSocketIOExt from 'vue-socket.io-extended';
import { authService } from '@/services/auth.service';
// export const SocketInstance = socketio('https://sky-data-source.gratitude-software.in');

export const SocketInstance = socketio('');
Vue.config.productionTip = false
// GS-901: gs-pattern-library's custom elements (public/patterns-boot.js) are not Vue components
Vue.config.ignoredElements = [/^gs-/]
// GS-900: an operator's SES calls carry its token (only where VUE_APP_REQUIRE_SIGNIN is true)
authService.install();
Vue.use(new VueSocketIO({
  debug: true,
  connection: SocketInstance, //options object is Optional
  vuex: {
    store,
    actionPrefix: "SOCKET_",
    mutationPrefix: "SOCKET_"
  }
}), SocketInstance)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
